// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type LieferantenListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheLieferantenQuery = {
  search?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSucheLieferanten(): (
  query: SucheLieferantenQuery
) => Promise<LieferantenListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (query = {}) =>
      (await getAPI()).lieferanten.sucheLieferanten({ ...query }),
    [getAPI]
  );
}
